import { XIcon } from 'lucide-react';

export const ErrorDialog = ({
  title,
  children,
  onClose,
}: {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}) => {
  return (
    <div className="pointer-events-auto fixed inset-0 z-[9999] flex items-center justify-center overflow-y-auto bg-black/50 p-4">
      <div className="my-8 w-full max-w-2xl rounded-lg bg-white shadow-xl">
        <div className="p-6">
          <div className="flex items-center justify-between border-b pb-3">
            <h2 className="text-xl font-semibold text-red-600">{title}</h2>
            <button
              onClick={onClose}
              type="button"
              className="text-gray-400 hover:text-gray-600"
              aria-label="Close"
            >
              <XIcon className="h-5 w-5" />
            </button>
          </div>
          <div className="mt-4 max-h-[50vh] overflow-y-auto pr-2">
            {children}
          </div>
          <div className="mt-6 flex justify-end border-t pt-4">
            <button
              onClick={onClose}
              type="button"
              className="rounded-lg bg-red-600 px-4 py-2 text-white transition-colors hover:bg-red-700"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
